const getURL = (ref) => {
  switch (ref) {
    case "API":
      if (typeof window !== "undefined")
        if (window.location.href.indexOf("gridparser.com") >= 0) {
          return "https://api.gridparser.com";
        } else if (
          window.location.href.indexOf("homolog.gridparser.com") >= 0
        ) {
          return "https://homolog.gridparser.com:8001";
        } else {
          return "http://localhost:8000";
        }
    case "root":
      if (typeof window !== "undefined")
        return window.location.href.split(window.location.pathname)[0];

    default:
      return null;
  }
};

const saveAccessToken = (token) => {
  const expires = new Date();
  expires.setMinutes(expires.getMinutes() + 15); //15

  document.cookie = `accessToken=${token}; expires=${expires.toUTCString()}; path=/`;
};

const removeAccessToken = () => {
  const expires = new Date();
  expires.setMinutes(expires.getMinutes() + 15);

  document.cookie = `accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

const getAccessToken = () => {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    const [name, value] = cookie.split("=");

    if (name === "accessToken") {
      return value;
    }
  }

  return null;
};

const formatDate = (value, format) => {
  format = format.replace("date ", "");
  value = value.replace(/[^\d]/g, "");

  switch (format) {
    case "yyyymmdd":
      return (
        value.substring(6, 8) +
        "/" +
        value.substring(4, 6) +
        "/" +
        value.substring(0, 4)
      );
    case "ddmmyyyy":
      return (
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 8)
      );
    case "yymmdd":
      return (
        value.substring(4, 6) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(0, 2)
      );
    case "ddmmyy":
      return (
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 6)
      );
    default:
      return value;
  }
};

const getTokenData = () => {
  const token = getAccessToken();

  let objToken = {
    id: "",
    email: "",
    exp: "",
  };

  if (token) {
    var dataToken = JSON.parse(atob(token.split(".")[1]));
    let now = Math.floor(Date.now() / 1000);
    let exp = dataToken.exp;
    if (exp < now) {
      document.cookie =
        "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      return objToken;
    }

    objToken.id = dataToken.id;
    objToken.email = dataToken.email;
    objToken.exp = dataToken.exp;

    return objToken;
  } else {
    return objToken;
  }
};

export {
  getURL,
  formatDate,
  saveAccessToken,
  removeAccessToken,
  getAccessToken,
  getTokenData,
};
